
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import moment from 'moment';

@Options({})
export default class dayProgressBar extends Vue {

    @Prop() startHour: number;
    @Prop() endHour: number

    progress: number = 0;
    currentHour: number = 0;
    currentTime: string = "";
    clockInterval = null;

    mounted(){
        this.currentTime = new Date().toISOString();
        this.clockInterval = setInterval(() => {
            this.currentTime = new Date().toISOString();
        }, 1000);
        this.calculateProgress();
    }

    calculateProgress(){
        this.currentHour = moment(new Date()).get('hour');
        if(this.currentHour < this.startHour || this.currentHour > this.endHour){
            this.progress = 0;
            return;
        }
        let emptyBar = this.$refs.emptyBar as HTMLDivElement;
        let pxWidth = emptyBar.getBoundingClientRect().width - 40; // remove 10 px from each side
        let currentHourMinusStart = this.currentHour - this.startHour;
        let totalHours = this.endHour - this.startHour;
        // current : x = totalHours : 100
        let progressPerc = currentHourMinusStart / totalHours;
        this.progress = pxWidth * progressPerc;
    }

    beforeUnmount() {
        clearInterval(this.clockInterval);
    }

}
